module.exports = __webpack_public_path__ + "static/img/3.d04ee7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/supply/3.png
// module id = ZrrA
// module chunks = 1